import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import VocabularyTable from '@/components/organisms/Table/VocabularyTable';
import { studentWordbookApi } from '@/services/api';
import { getSlugPrefix } from '@/utils/slug';

interface VocabularyData {
  id: number;
  name: string;
  wordCount: number;
  learningHistory: string;
  registrationDate: string;
}

// 단어장 리스트
export default function StudentVocabularyList() {
  const navigate = useNavigate();
  const location = useLocation();
  const slugPrefix = getSlugPrefix(location.pathname);
  const [searchText, setSearchText] = useState('');
  const [rows, setRows] = useState<VocabularyData[]>([]);
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchList = async (p = page, overrideQ?: string) => {
    try {
      setLoading(true);
      const q = typeof overrideQ === 'string' ? overrideQ : searchText;
      
      console.log('🔍 학생 단어장 API 호출:', { q, page: p - 1, size: pageSize });
      
      // @ts-ignore
      const res = await studentWordbookApi.list({ q, page: p - 1, size: pageSize });
      
      console.log('📦 학생 단어장 API 응답:', res);
      
      const apiData = res?.data || res;
      const content = apiData?.content || [];
      const total = apiData?.totalElements ?? 0;
      
      console.log('✅ 변환된 데이터:', { content, total });
      
      setRows(content.map((item: any) => ({
        id: item.id,
        name: item.title,
        wordCount: item.itemCount || 0,
        learningHistory: item.learningStatus || '학습 대기',
        registrationDate: (item.createdAt || '').toString().substring(0, 10)
      })));
      
      setPage(p);
      setTotalElements(total);
      setTotalPages(Math.max(1, Math.ceil(total / pageSize)));
    } catch (error) {
      console.error('❌ 학생 단어장 API 호출 에러:', error);
      setRows([]);
      setTotalElements(0);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pParam = Number(params.get('page') || '1');
    const qParam = params.get('q') || '';
    
    if (searchText !== qParam) setSearchText(qParam);
    
    fetchList(pParam, qParam);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const handleSearchChange = (text: string) => {
    setSearchText(text);
  };

  const handleSearch = () => {
    console.log('🔎 검색 실행:', searchText);
    const params = new URLSearchParams();
    params.set('page', '1');
    if (searchText) params.set('q', searchText);
    navigate(`${slugPrefix}/vocabulary/list?${params.toString()}`);
  };

  const handlePageChange = (newPage: number) => {
    const params = new URLSearchParams();
    params.set('page', String(newPage));
    if (searchText) params.set('q', searchText);
    navigate(`${slugPrefix}/vocabulary/list?${params.toString()}`);
  };

  return (
    <main className='flex flex-1 justify-center w-full bg-white lg:my-10 card md:py-5 md:bg-transparent'>
        <div className='flex flex-col w-full'>
            <h1 className='px-5 pb-3 heading1'>단어장</h1>
                <section className='flex flex-1 px-5 w-full lg:px-0'>
                    <VocabularyTable 
                      data={rows}
                      searchText={searchText}
                      onSearchChange={handleSearchChange}
                      onSearch={handleSearch}
                      currentPage={page}
                      totalElements={totalElements}
                      pageSize={pageSize}
                      onPageChange={handlePageChange}
                      loading={loading}
                    />
                </section>
            </div>
    </main>
  );
}